import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid, Label, Icon } from "semantic-ui-react";
import moment from "moment";
import { formatCurrency } from "../../utils/constants";
import { AppContext } from "../../utils/context";

function pad(number, size) {
  var s = String(number);
  while (s.length < (size || 2)) {
    s = "0" + s;
  }
  return s;
}

class EventTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      summary: {},
      eventStart: "",
      eventEnd: "",
      dd: 0,
      hh: 0,
      mm: 0,
      ss: 0,
      animation: "pulse",
      duration: 200,
      visible: true,
      timer: false
    };
  }
  componentDidMount = () => { };
  componentWillUnmount = () => {
    clearInterval(this.state.timer);
  };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.summary !== prevProps.summary) {
      this.setState({
        summary: this.props.summary,
        eventStart: this.props.summary.start_at,
        eventEnd: this.props.summary.end_at
      });
      clearInterval(this.state.timer);
      setTimeout(this.startTimer, 500);
    }
  };
  startTimer = () => {
    let self = this;
    // moment countdown example
    let interval = 1000;
    let duration = 0;
    let eventTime = moment(self.state.eventEnd).unix();
    let currentTime = moment().unix();
    let diffTime = eventTime - currentTime;
    duration = moment.duration(diffTime * 1000, "milliseconds");

    if (duration < 0) {
      duration = moment.duration(0, "milliseconds");
    }

    let timerInterval = setInterval(function () {
      duration = moment.duration(duration - interval, "milliseconds");
      if (duration <= 0) {
        clearInterval(timerInterval);
        return;
      }
      if (duration <= 60000) self.setState({ visible: false });
      self.setState({
        dd: pad(duration.days(), 2),
        hh: pad(duration.hours(), 2),
        mm: pad(duration.minutes(), 2),
        ss: pad(duration.seconds(), 2),
        visible: true
      });
    }, interval);

    self.setState({
      timer: timerInterval
    });
  };
  render() {
    const { dd, hh, mm, ss, summary } = this.state;
    const { event, pause, startStopShopify } = this.props;
    let totalSales = summary.sales ? summary.sales.total: 0;
    
    return (
      <Grid doubling>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Label.Group size="large">
            <Label color="olive">
              {totalSales ? (
                formatCurrency(totalSales)
              ) : (
                <Icon loading name="spinner" />
              )}{" "}
              <Label.Detail>Sales</Label.Detail>
            </Label>
            <Label color="red">
              {summary.jackpot ? (
                formatCurrency(summary.jackpot.expenses)
              ) : (
                <Icon loading name="spinner" />
              )}{" "}
              <Label.Detail>Expenses</Label.Detail>
            </Label>
            {event.game_id !== 2 && <Label color="green">
              {summary.jackpot ? (
                formatCurrency(summary.jackpot.jackpot, 2)
              ) : (
                <Icon loading name="spinner" />
              )}{" "}
              <Label.Detail>
                {event.game_id === 3 && this.context.language.en.game_3_jackpot_title_short}
                {event.game_id === 2 && this.context.language.en.game_2_jackpot_title}
                {event.game_id === 1 && this.context.language.en.game_1_jackpot_title}
              </Label.Detail>
            </Label>}
            <Label color="blue">
              {summary.jackpot ? (
                event.game_id === 2 ? summary.jackpot.prize : formatCurrency(summary.jackpot.prize, 2)
              ) : (
                <Icon loading name="spinner" />
              )}{" "}
              <Label.Detail>
                {event.game_id === 3 && this.context.language.en.game_3_prize_title}
                {event.game_id === 2 && this.context.language.en.game_2_prize_title}
                {event.game_id === 1 && this.context.language.en.game_1_prize_title}
              </Label.Detail>
            </Label>
          </Label.Group>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8} textAlign="right">

          <Label.Group size="large">
            {+event.webenabled > 0 && (
              <Label color="green" as="a" onClick={() => window.open(event.weburl)}>
                <Icon name="globe" color="blue" />
                E-commerce Site
              </Label>
            )}
            {+event.shopify_enabled > 0 && event.shopify_storefront !== "" && (
              <Label color="purple" as="a" onClick={() => window.open(event.shopify_storefront)}>
                <Icon name="globe" color="white" />
                Shopify Storefront
              </Label>
            )}
            {+event.shopify_enabled > 0 && event.shopify_storefront !== "" && (
              <Label color={event.shopify_seller_deactivated === 1 ? "green" : "red"} 
                as="a" onClick={startStopShopify}>
                <Icon name="globe" color="white" />
                {+event.shopify_seller_deactivated === 1
                  ? "Start Shopify Sales"
                  : "Stop Shopify Sales"}
              </Label>
            )}
            <Label color="black">
              {dd} <Label.Detail>D</Label.Detail>
            </Label>
            <Label color="black">
              {hh} <Label.Detail>H</Label.Detail>
            </Label>
            <Label color="black">
              {mm} <Label.Detail>M</Label.Detail>
            </Label>
            <Label color="black">
              {ss} <Label.Detail>S</Label.Detail>
            </Label>
            {summary.is_active === true && +event.webenabled === 1 && (
              <Label
                as="a"
                color={+event.web_sales_paused === 1 ? "green" : "yellow"}
                onClick={pause}
              >
                <Icon
                  name={+event.web_sales_paused === 1 ? "play" : "pause"}
                />{" "}
                {+event.web_sales_paused === 1
                  ? "Start E-commerce Sales"
                  : "Pause E-commerce Sales"}
              </Label>
            )}
            {summary.is_active === true && (
              <Label color="red" as={Link} to={`/events/${event.id}/devices`} >
                <Icon name="stop" />
                End Event
              </Label>
            )}
          </Label.Group>
        </Grid.Column>
      </Grid>
    );
  }
}

EventTimer.contextType = AppContext;

export default EventTimer;
